module.exports = __webpack_public_path__ + "static/motorola-01ecc0b877aa7d084920ff5c67396067.png";